module.exports = __webpack_public_path__ + "fonts/fa-solid-900.9822daf6.woff";